import React, { useEffect, useState } from "react";
import { CreacionTrasladoAlmacenApi } from "../api/CreacionTrasladoAlmacenApi";
import { NotificationManager } from "react-notifications";
import Swal from "sweetalert2";
import { getErrorFromResponse } from "../../../../../../../utility/utils";

export const useCreacionTrasladoAlmacen = (almacenId, regresar) => {
    const { getAlmacenDetalle, cargando } = CreacionTrasladoAlmacenApi();

    const [almacenDetalle, setAlmacenDetalle] = useState({});

    const GetAlmacenDetalle = async () => {
        try {
            const data = await getAlmacenDetalle(almacenId);

            setAlmacenDetalle(data);
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener el detalle del almacen",
            );
            Swal.fire({
                title: "Error",
                text: errorMsg,
                type: "error",
            });
            setAlmacenDetalle({});
        }
    };

    useEffect(() => {
        GetAlmacenDetalle();
    }, [almacenId]);

    return {
        almacenDetalle,

        cargando,
    };
};
